export default {
  data() {
    return {
      flagTooltip: false
    }
  },
  methods: {
    showTooltip(e, index, type, num) {
      const maxWidth = num || e.target.offsetWidth
      const width = this.$refs[`${type}${index}`][0].offsetWidth
      if (width > maxWidth) {
        this.flagTooltip = false
      } else {
        this.flagTooltip = true
      }
    }
  }
}
